import { FC, HTMLProps } from 'react';

export const ArrowLeftIcon: FC<HTMLProps<SVGSVGElement>> = (props) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="14"
      height="14"
      viewBox="0 0 14 14"
      fill="none"
      {...props}
    >
      <g clipPath="url(#clip0_169_2788)">
        <path
          d="M10.1719 0.232411C9.97135 0.0592346 9.74349 -0.018239 9.48828 -9.53674e-06C9.23307 0.0182199 9.01888 0.127594 8.8457 0.328115L3.73242 6.38476C3.57747 6.55793 3.5 6.76301 3.5 6.99999C3.5 7.23697 3.57747 7.44205 3.73242 7.61522L8.8457 13.6719C9.01888 13.8724 9.23307 13.9818 9.48828 14C9.74349 14.0182 9.97135 13.9407 10.1719 13.7676C10.3724 13.6035 10.4818 13.3893 10.5 13.125C10.5182 12.8607 10.4408 12.6282 10.2676 12.4277L5.67383 6.99999L10.2676 1.57226C10.4408 1.37173 10.5182 1.13931 10.5 0.87499C10.4818 0.610666 10.3724 0.396474 10.1719 0.232411Z"
          fill="currentColor"
        />
      </g>
      <defs>
        <clipPath id="clip0_169_2788">
          <rect width="14" height="14" fill="white" transform="matrix(1 0 0 -1 0 14)" />
        </clipPath>
      </defs>
    </svg>
  );
};
